import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  ListItemText,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import React from "react";
import { daysOfWeek, monthDates } from "./taskSchedulerUtils";

function TaskSchedulerSchedule({
  frequency,
  weekDays,
  monthDays,
  dayOfMonth,
  monthOfYear,
  startDate,
  endDate,
  time,
  active,
  onFrequencyChange,
  onWeekDaysChange,
  onMonthDaysChange,
  onDayOfMonthChange,
  onMonthOfYearChange,
  onStartDateChange,
  onEndDateChange,
  onTimeChange,
  onActiveChange,
}) {
  return (
    <Box
      sx={{
        "& .MuiTextField-root": { m: 1, width: "95%" },
        "& .MuiFormControl-root": { m: 1 },
      }}
    >
        <FormControl variant="outlined" fullWidth  sx={{ m: 1, width: "98%" }}>
          <InputLabel id="task-scheduler-frequency-label" size="small">
            Frequency
          </InputLabel>
          <Select
            labelId="task-scheduler-frequency-label"
            id="task-scheduler-frequency"
            value={frequency}
            label="Frequency"
            size="small"
            onChange={onFrequencyChange}
          >
            <MenuItem value="DAILY">Daily</MenuItem>
            <MenuItem value="WEEKLY">Weekly</MenuItem>
            <MenuItem value="MONTHLY">Monthly</MenuItem>
            <MenuItem value="QUARTERLY">Quarterly</MenuItem>
            <MenuItem value="YEARLY">Yearly</MenuItem>
          </Select>
        </FormControl>

        {frequency === "WEEKLY" && (
          <FormControl variant="outlined" fullWidth sx={{  m: 1, width: "98%" }} >
            <InputLabel id="task-scheduler-weekdays-label">
              Select Days
            </InputLabel>
            <Select
              labelId="task-scheduler-weekdays-label"
              multiple
              value={weekDays}
              size="small"
              label="Select Days"
              onChange={onWeekDaysChange}
              renderValue={(selected) => selected.join(", ")}
            >
              {daysOfWeek.map((day) => (
                <MenuItem key={day} value={day}>
                  <Checkbox checked={weekDays.indexOf(day) > -1} />
                  <ListItemText primary={day} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {frequency === "MONTHLY" && (
          <FormControl fullWidth sx={{ mb: 2, m: 1, width: "98%" }} >
            <InputLabel id="task-scheduler-monthdays-label">
              Select Dates
            </InputLabel>
            <Select
              labelId="task-scheduler-monthdays-label"
              multiple
              label="Select Dates"
              value={monthDays}
              onChange={onMonthDaysChange}
              renderValue={(selected) => selected.join(", ")}
            >
              {monthDates.map((date) => (
                <MenuItem key={date} value={date}>
                  <Checkbox checked={monthDays.indexOf(date) > -1} />
                  <ListItemText primary={date} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {frequency === "YEARLY" && (
          <Box sx={{ display: "flex" }}>
              <TextField
                sx={{  width: "48%" }}
                type="number"
                label="Day"
                value={dayOfMonth}
                onChange={onDayOfMonthChange}
                inputProps={{ min: 1, max: 31 }}
              />
              <TextField
                sx={{  width: "48%" }}
                type="number"
                label="Month (1-12)"
                value={monthOfYear}
                onChange={onMonthOfYearChange}
                inputProps={{ min: 1, max: 12 }}
              />
          </Box>
        )}

        <Box
          sx={{
            display: "flex",
            // gap: 1,
            // width: "100%",
            // flexWrap: "wrap",
            // alignItems: "flex-start",
          }}
        >
          <DatePicker
            label="Start"
            value={startDate}
            onChange={onStartDateChange}
            slotProps={{
              textField: {
                margin: "dense",
                sx: { m: 1, minWidth: "47%" },
              },
            }}
          />

          <DatePicker
            label="End"
            value={endDate}
            minDate={startDate}
            onChange={onEndDateChange}
            slotProps={{
              textField: {
                margin: "dense",
                sx: { m: 1, minWidth: "47%" },
              },
            }}
          />
        </Box>
        <Box sx={{ display: "flex", width: "100%", gap: 1, alignItems: "flex-start" }}>
          <TimePicker
            label="Run Time"
            sx={{ m: 1}}
            value={time}
            onChange={onTimeChange}
            slotProps={{
              textField: {
                margin: "dense",
              },
            }}
          />

          <FormControl sx={{  m: 1, minWidth: "47%" }}>
            <FormLabel id="task-scheduler-active-label">Active</FormLabel>
            <RadioGroup
              row
              aria-labelledby="task-scheduler-active-label"
              name="task-scheduler-active"
              value={active}
              onChange={onActiveChange}
            >
              <FormControlLabel
                value={true}
                control={<Radio />}
                label="Yes"
              />
              <FormControlLabel
                value={false}
                control={<Radio />}
                label="No"
              />
            </RadioGroup>
          </FormControl>
        </Box>
    </Box>
  );
}

export default TaskSchedulerSchedule;
